/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

import { IVodSocuLastViewedPositionServiceRepository } from '../interfaces/IVodSocuLastViewedPositionServiceRepository';
import { VodSocuLastViewedPositionRepositoryImpl } from '../impls/VodSocuLastViewedPositionRepositoryImpl';
import { TServicesParams, TSocuLastViewedPositionParams } from '../types';

export class VodSocuLastViewedPositionService
    implements IVodSocuLastViewedPositionServiceRepository
{
    private oVodSocuLVPServiceRepository: VodSocuLastViewedPositionRepositoryImpl;

    constructor(params: TServicesParams) {
        this.oVodSocuLVPServiceRepository = new VodSocuLastViewedPositionRepositoryImpl(params);
    }

    async setSocuLastViewedPosition(socuLVPParams: TSocuLastViewedPositionParams): Promise<void> {
        return this.oVodSocuLVPServiceRepository.setSocuLastViewedPosition(socuLVPParams);
    }
}
